import { api as apiService, ApiService } from "./api"

export interface Batch {
  id: number
  batchId: number
  scheduledDate: string
  updatedBy: string
  isDeleted: boolean
  created: string
  updated: string
}

export interface BaseProduct {
  productBaseId: number
  productBaseName: string
  Batchs: Batch[]
}

export interface BatchResponse {
  totalCount: number
  pageIndex: number
  pageSize: number
  results: BaseProduct[]
}

class BatchService {
  private api: ApiService

  constructor(api: ApiService) {
    this.api = api
  }

  public getAllBaseProducts = async (params: any): Promise<BatchResponse> => {
    const response = await this.api.get(`${toranjaURL}/batch/`, {
      params,
    })
    return response
  }

  public createBaseProduct = async (data: {
    batchId: number
    scheduledDate: string
  }): Promise<void> => {
    await this.api.post(`${toranjaURL}/batch/`, data)
  }

  public create = async (data: {
    batchId: number
    productBaseId: number
    scheduledDate: string
  }): Promise<void> => {
    await this.api.post(`${toranjaURL}/batch/`, data)
  }

  public update = async (
    id: number,
    data: { batchId: number; scheduledDate: string },
  ): Promise<void> => {
    await this.api.put(`${toranjaURL}/batch/${id}`, data)
  }

  public patch = async (id: number, data: any): Promise<void> => {
    await this.api.patch(`${toranjaURL}/batch/${id}`, data)
  }

  public delete = async (id: number | undefined): Promise<void> => {
    await this.api.delete(`${toranjaURL}/batch/${id}`)
  }

  public createByExcel = async (data: any): Promise<any> => {
    await this.api.post(`${toranjaURL}/batch/upload/file`, data)
  }

  public downloadExcel = async () => {
    return this.api.get(`${toranjaURL}/batch/upload`, { responseType: "blob" })
  }
}

const toranjaURL = process.env.REACT_APP_TORANJA_API
export const batchService = new BatchService(apiService)
